export default function (props?: { CNPJs?: string[] | string; stdout?: boolean }) {
	const { CNPJs, stdout } = props || {};

	const target: string[] = CNPJs
		? typeof CNPJs === 'string'
			? [CNPJs]
			: CNPJs
		: [(window.Redux('posReducer').myPos as any[]).find(({ isSelected }) => isSelected).cnpj];


	const EANs: string[] = window.getEANs();

	const orderImportLines = target.reduce((accPos, pos) => {
		accPos += `${EANs.reduce((accEAN, ean) => {
			accEAN += `${pos};${ean};1\n`;

			return accEAN;
		}, '')}`

		return accPos;
	}, '');

	if (stdout) return orderImportLines;
	console.log(orderImportLines)
};